export default __webpack_public_path__ + "static/media/thumb-seller.a801d402.png";